import React from 'react';
import { useTranslation } from 'react-i18next';
import './StreakDisplay.css';

/**
 * StreakDisplay - shows a flame icon with streak counter
 * Accepts either:
 *   - streak={Object} with { currentStreak, bestStreak } (from challenges API)
 *   - streak={number}, bestStreak={number} (legacy)
 */
export default function StreakDisplay({ streak = 0, bestStreak = 0, compact = false }) {
  const { t } = useTranslation();

  // Support both object and number formats
  let current, best;
  if (typeof streak === 'object' && streak !== null) {
    current = streak.currentStreak || 0;
    best = streak.bestStreak || 0;
  } else {
    current = streak || 0;
    best = bestStreak || 0;
  }

  if (current === 0 && compact) {
    return null;
  }

  // Determine flame intensity based on streak length
  const getFlameClass = () => {
    if (current >= 30) return 'streak-legendary';
    if (current >= 14) return 'streak-epic';
    if (current >= 7) return 'streak-hot';
    if (current >= 3) return 'streak-warm';
    return 'streak-start';
  };

  if (compact) {
    return (
      <span
        className={`streak-display-compact ${getFlameClass()}`}
        title={t('challenges.current_streak', 'Current Streak')}
      >
        <i className="fas fa-fire streak-flame-icon"></i> {current}
      </span>
    );
  }

  return (
    <div className={`streak-display ${getFlameClass()}`}>
      <div className="streak-current">
        <i className="fas fa-fire streak-flame-icon"></i>
        <div className="streak-info">
          <span className="streak-count">{current}</span>
          <span className="streak-label">{t('challenges.day_streak', 'Day Streak')}</span>
        </div>
      </div>
      {best > 0 && (
        <div className="streak-best">
          <span className="streak-best-label">{t('challenges.best', 'Best')}: </span>
          <span className="streak-best-count">{best}</span>
        </div>
      )}
    </div>
  );
}
